import React from 'react';

const NotFound = () => {
    return (
        <div>
            404 page not found
        </div>
    );
};

export default NotFound;